import React from 'react';
import { useParams } from 'react-router-dom';
import List from '@mui/material/List';
import GridViewIcon from '@mui/icons-material/GridView';
import PeopleIcon from '@mui/icons-material/People';
import KeyIcon from '@mui/icons-material/Key';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FolderIcon from '@mui/icons-material/Folder';
import ListIcon from '@mui/icons-material/List';
import ExportIcon from '@mui/icons-material/FileDownload';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import DevicesIcon from '@mui/icons-material/Devices';
import AppsIcon from '@mui/icons-material/PhoneAndroid';
import OrganizationsIcon from '@mui/icons-material/Apartment';
import ToolsIcon from '@mui/icons-material/Handyman';
import SidebarMenuItem from './SidebarMenuItem';
import SidebarExternalMenuItem from './SidebarExternalMenuItem';
import SidebarMenuGroup from './SidebarMenuGroup';
import { addHost } from '../utils/urls';
import AppRoutes from '../router/routes';

export default function SidebarMenu() {
  const { projectId } = useParams();

  return (
    <List>
      <SidebarMenuItem
        linkTarget={AppRoutes.Root}
        translationId="sidebarmenu.links.projects"
        icon={<GridViewIcon />}
      />
      <SidebarMenuItem
        linkTarget={AppRoutes.Apps}
        translationId="sidebarmenu.links.apps"
        icon={<AppsIcon />}
      />
      <SidebarMenuItem
        linkTarget={AppRoutes.Realms}
        translationId="sidebarmenu.links.realms"
        icon={<PeopleIcon />}
      />
      <SidebarMenuItem
        linkTarget={AppRoutes.CortexDecoderKeys}
        translationId="sidebarmenu.links.cortexDecoderKeys"
        icon={<KeyIcon />}
      />
      <SidebarMenuItem
        linkTarget={AppRoutes.Organizations}
        translationId="sidebarmenu.links.organizations"
        icon={<OrganizationsIcon />}
      />
      <SidebarMenuGroup
        translationId="sidebarmenu.links.tools"
        icon={<ToolsIcon />}
      >
        <SidebarMenuItem
          linkTarget={AppRoutes.ToolsDynaformPreview}
          translationId="sidebarmenu.links.dynaFormPreview"
        />
      </SidebarMenuGroup>
      {projectId && (
        <>
          <hr />
          <SidebarMenuItem
            linkTarget={AppRoutes.Project(projectId)}
            translationId="sidebarmenu.links.projectConfig"
            icon={<SettingsIcon />}
          />
          <SidebarMenuGroup
            translationId="sidebarmenu.links.checkoutConfig"
            icon={<ShoppingCartIcon />}
          >
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutGeneral(projectId)}
              translationId="sidebarmenu.links.generalConfig"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutPaymentConfiguration(projectId)}
              translationId="sidebarmenu.links.paymentConfig"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutVpos(projectId)}
              translationId="sidebarmenu.links.vpos"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutTseConfiguration(projectId)}
              translationId="sidebarmenu.links.tseConfig"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutTaxCategories(projectId)}
              translationId="sidebarmenu.links.taxCategories"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutDiscountReasons(projectId)}
              translationId="sidebarmenu.links.discountReasons"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutFulfillmentConfig(projectId)}
              translationId="sidebarmenu.links.fulfillmentConfig"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutFlows(projectId)}
              translationId="sidebarmenu.links.flow"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutControlConfig(projectId)}
              translationId="sidebarmenu.links.controlConfig"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutCheckConfig(projectId)}
              translationId="sidebarmenu.links.checkConfig"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutCustomerPropertiesLookup(projectId)}
              translationId="sidebarmenu.links.customerPropertiesLookup"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutCustomerValidation(projectId)}
              translationId="sidebarmenu.links.customerValidation"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutVoucherProviders(projectId)}
              translationId="sidebarmenu.links.voucherProviders"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutDepositReturnVoucherProviders(
                projectId,
              )}
              translationId="sidebarmenu.links.depositReturnVoucherProviders"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutServiceCredentials(projectId)}
              translationId="sidebarmenu.links.serviceCredentials"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutCouponConfiguration(projectId)}
              translationId="sidebarmenu.links.couponConfiguration"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutSets(projectId)}
              translationId="sidebarmenu.links.sets"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutReturn(projectId)}
              translationId="sidebarmenu.links.return"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutOverrideTemplates(projectId)}
              translationId="sidebarmenu.links.overrideTemplates"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutCash(projectId)}
              translationId="sidebarmenu.links.cash"
            />
          </SidebarMenuGroup>
          <SidebarMenuGroup
            translationId="sidebarmenu.links.transactionConfig"
            icon={<FolderIcon />}
          >
            <SidebarMenuItem
              linkTarget={AppRoutes.TransactionTransactions(projectId)}
              translationId="sidebarmenu.links.transactions"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.TransactionReporting(projectId)}
              translationId="sidebarmenu.links.reporting"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.TransactionClosingLogSink(projectId)}
              translationId="sidebarmenu.links.closingLogSinks"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.TransactionCleanupSchedule(projectId)}
              translationId="sidebarmenu.links.cleanupRoutines"
            />
          </SidebarMenuGroup>
          <SidebarMenuGroup
            translationId="sidebarmenu.links.checkoutDevices"
            icon={<DevicesIcon />}
          >
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutDevicesDynaConfig(projectId)}
              translationId="sidebarmenu.links.dynaConfig"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.CheckoutDevicesAvailableTypes(projectId)}
              translationId="sidebarmenu.links.availableDevices"
            />
          </SidebarMenuGroup>
          <SidebarMenuItem
            linkTarget={AppRoutes.Sidebar(projectId)}
            translationId="sidebarmenu.links.sidebar"
            icon={<ListIcon />}
          />
          <SidebarMenuGroup
            translationId="export.links.sidebar"
            icon={<ExportIcon />}
          >
            <SidebarMenuItem
              linkTarget={AppRoutes.Export(projectId)}
              translationId="export.links.standard"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.ExportThirdParty(projectId)}
              translationId="export.links.thirdParty"
            />
            <SidebarMenuItem
              linkTarget={AppRoutes.ExportTransactionsStatistics(projectId)}
              translationId="export.links.transactionsStatistics"
            />
          </SidebarMenuGroup>
          <SidebarExternalMenuItem
            linkTarget={addHost(window.location, `/${projectId}`, 'retailer')}
            translationId="sidebarmenu.links.retailerPortal"
            icon={<DoubleArrowIcon />}
          />
        </>
      )}
    </List>
  );
}
